import React, { useEffect, useRef, useState, useContext } from "react";
import { makeStyles, withStyles } from "@mui/styles";
import Dialog from "@mui/material/Dialog";
import MuiDialogTitle from "@mui/material/DialogTitle";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import ImageCropper from '../questionComponents/ImageCropper';

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexShrink: 0,
    [theme.breakpoints.up("sm")]: {
      flexBasis: "85%",
    },
    [theme.breakpoints.down("xs")]: {
      flexBasis: "85%",
    },
    cursor: "pointer",
  },
}));

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: "#fff",
    backgroundColor: "rgba(0, 0, 0, 0.55)",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.75)",
    },
  },
});
const ImageCropperDialog = (props) => {
  const classes = useStyles();
  
  const DialogTitleCropper = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    )
  })

  const DialogContentCropper = withStyles((theme) => ({
    root: {
      marginTop: theme.spacing(4),
    },
  }))(MuiDialogContent);

  const DialogActions = withStyles((theme) => ({
    root: {
      margin: 0,
      padding: theme.spacing(1),
    },
  }))(MuiDialogActions);
  return (
    <Dialog
      onClose={props.onClose}
      maxWidth="sm"
      fullWidth
      aria-labelledby="customized-dialog-title"
      open={props.open}
    >
      <DialogTitleCropper
        id="customized-dialog-title"
        onClose={props.onClose}
      >
      </DialogTitleCropper>
      <DialogContentCropper>
        <ImageCropper src={props.data} saveCroppedImage={props.saveCroppedImage}
        onClose ={props.onClose}
          />
      </DialogContentCropper>
    </Dialog>
  )
}

export default ImageCropperDialog;
